import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";

function OverlayLoader() {
  return (
    <Backdrop sx={(theme) => ({ color: "#fff", zIndex: "1000" })} open={true} onClick={() => {}}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export default OverlayLoader;
